import React, { useEffect, useState } from 'react'
import { getInfrastructureProjects } from '../../../requests/public-infrastructure'
import { useParams } from 'react-router-dom'
import { IInfrastructureProject, InfrastructureProjectType } from '../../../types/project.types'
import classes from '../infrastructure-tabs/styles.module.scss';
import { MinusIcon, PlusBigIcon } from '../../../assets/icons';
import { useTranslation } from 'react-i18next';
import AdditionalFields from '../components/additional-fields.component';
import { convertFilesToImageDate } from '../../../helpers/utils';
import ImageGrid from '../components/image-grid.component';

const translationKey = 'projects.SNP_INVESTMENT';

const InvestmentProjectsTab = () => {
  const { t, i18n: { language } } = useTranslation();
  const { kato } = useParams<{ kato: string }>()
  const [list, setList] = useState<IInfrastructureProject[]>([])
  const [isOpen, setIsOpen] = useState<Record<number, boolean>>({})
  const suffix = language === 'ru' ? 'Ru' : 'Kz';

  const renderFieldRowItem = (labelKey: string, value: string | number | undefined, unit?: string) => (
    <div className={classes['field-row__item']}>
      <span className={classes['field-row__label']}>{t(labelKey)}:</span>
      <span className={classes['field-row__value']}>
        {value} {unit || ''}
      </span>
    </div>
  );

  useEffect(() => {
    if (!kato) return;
    getInfrastructureProjects(kato, InfrastructureProjectType.SNP_INVESTMENT)
      .then((res: any) => {
        setList(res);
      })
      .catch((error: any) => {
        console.error('Error fetching investment projects:', error);
      });
  }, [kato])

  return (
    <div className={classes['items-list']}>
      {list.map(item => (
        <div key={item.id} className={classes['project-item']}>
          <div
            className={classes['project-item__header']}
            onClick={() =>
              setIsOpen(prev => ({ ...prev, [item.id]: !prev[item.id] }))
            }
          >
            <div className={classes['project-item__icon']}>
              {isOpen[item.id] ? <MinusIcon /> : <PlusBigIcon />}
            </div>
            <span className={classes['project-item__title']}>
              {item[`name${suffix}`] ?? '-'}
            </span>
          </div>

          {isOpen[item.id] && (
            <div className={classes['project-item__body']}>
              <div className={classes['field-row']}>
                {['realizationYear', 'projectPower', 'investmentFund', 'workPlaceNumber', 'shortDescription', 'expectedEffect'].map(field => {
                  const valueKey = ['projectPower', 'shortDescription', 'expectedEffect'].includes(field) ? `${field}${suffix}` : field;
                  const value = item[valueKey as keyof IInfrastructureProject] as string | number | undefined;
                  return renderFieldRowItem(`${translationKey}.${field}`, value);
                })}
              </div>

              {item.additionalFields && <AdditionalFields data={item.additionalFields} />}
              {item.files && <ImageGrid images={convertFilesToImageDate(item.files)} />}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default InvestmentProjectsTab